import { ErrorHandler, inject, Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from '../services/toast.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  toastService = inject(ToastService);
  translate = inject(TranslateService);
  handleError(error: HttpErrorResponse): void {
    console.error('Global error handler trigger:', error);
  //   this.toastService.openSnackbar({ message: this.translate.instant('error.unexpectedErrorTryAgain'),
  //          icon: 'error'
  //         });
   }
}
